import { render, staticRenderFns } from "./OrganismVamosPaLaCalleButtonsRow.vue?vue&type=template&id=59ef1972"
import script from "./OrganismVamosPaLaCalleButtonsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganismVamosPaLaCalleButtonsRow.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports